import type { StorageMetricsBehaviors } from "./types.js";
import type { MittwaldAPIV2Client } from "@mittwald/api-client-NEXT";
import { assertOneOfStatus } from "@mittwald/api-client-NEXT";

export const apiStorageMetricsBehaviors = (
  client: MittwaldAPIV2Client,
): StorageMetricsBehaviors => ({
  findByServer: async (serverId) => {
    const response = await client.project.storagespaceGetServerStatistics({
      serverId,
    });

    if (response.status === 200) {
      return response.data;
    }
    assertOneOfStatus(response, [403]);
  },

  findByProject: async (projectId) => {
    const response = await client.project.storagespaceGetProjectStatistics({
      projectId,
    });

    if (response.status === 200) {
      return response.data;
    }
    assertOneOfStatus(response, [403]);
  },
});
